import { useAtomValue } from 'jotai/index';

import { surveyStatusAtom } from '@/lib/stores/survey/common';

export const useSurveyUserEventAttributes = () => {
  const surveyStatus = useAtomValue(surveyStatusAtom);

  return {
    'deduction.type': surveyStatus.deductionTypes.join('.')
  };
};
